import { SAGA_STATUS_FINISH, SAGA_STATUS_ERROR, SAGA_STATUS_BEGIN } from '../actions/types';

export const initialState = {
  instances: 0,
  errors: {},
  loading: {},
};

export const sagaStatus = (state = initialState, action) => {
  switch (action.type) {
    case SAGA_STATUS_BEGIN: {
      const { name } = action.payload;
      if (name) {
        state.errors[name] = '';
        state.loading[name] = true;
      }
      state.instances += 1;
      return state;
    }
    case SAGA_STATUS_FINISH: {
      const { name } = action.payload;
      if (name) {
        state.errors[name] = '';
        state.loading[name] = false;
      }
      state.instances -= 1;
      return state;
    }
    case SAGA_STATUS_ERROR: {
      const { name, error } = action.payload;
      if (name) {
        state.errors[name] = error;
        state.loading[name] = false;
      }
      return state;
    }
    default:
      return state;
  }
};
